import { Section, Spinner, Wrapper } from '@ahmdigital/ui';
import React from 'react';

import styles from './styles.module.sass';

/**
 * @deprecated If you need to display a transition state for the entire content of a page please
 * prefer LoadingContent to avoid breaking accessibility rules.
 */
const LoadingSpinner = () => (
  <div className={styles.section} data-testid="loading-spinner">
    <Section>
      <Wrapper size="large">
        <Spinner />
      </Wrapper>
    </Section>
  </div>
);

export default LoadingSpinner;
